export const SoftwareUpdateEndpoint = 'https://hyperionwebapi-akerstromsvv.azurewebsites.net/api/';
